export * from "./MEdAttrList";
